module.exports = __webpack_public_path__ + "img/jorgesilva.9b4975d6.jpeg";